module.exports = {
    //Common Button
    "EVA_BTN_SEARCH": "ค้นหา",
    "EVA_BTN_CLEAR": "ล้างข้อมูล",
    "EVA_BTN_ADD": "เพิ่ม",

    "EVA_ACTIVE": "ใช้งาน",
    "EVA_INACTIVE": "ไม่ใช้งาน",

    "EVA_TITLE_SUBMIT_GRADE": 'กรอกเกรด',
    'EVA_GRADE_SUBMITTED': 'ส่งเกรดแล้ว',
    'EVA_GRADE_NOT_SUBMITTED': 'ยังไม่ได้ส่งเกรด',
    'EVA_NO_REGISTRANT':"ไม่มีผู้ลงทะเบียน",
    'EVA_LAST_DAY_FILL_OUT_GRADE': 'วันสุดท้ายของการกรอกเกรด',
    'EVA_LAST_DAY_TO_EDIT_I_N': 'วันสุดท้ายในการแก้ไข I/N',
    'EVA_UNDER_CONSIDERATION': 'อยู่ระหว่างการพิจารณา',
    'EVA_COMPLETED': 'เสร็จสมบูรณ์',
    'EVA_CANCEL': 'ยกเลิก',
    'EVA_NEED_VERIFICATION': 'ต้องการการตรวจสอบ',
    'EVA_NOT_APPROVED': 'ไม่อนุมัติ',
    'EVA_GRADE_SUBMISSION_PERIOD': 'อยู่ในช่วงส่งเกรดล่าช้า',
    'EVA_MAIN_INSTRUCTOR': 'ผู้สอนหลัก',
    'EVA_GRADER': 'ผู้กรอกเกรด',
    'EVA_LAST_EDIT_DATE': 'วันที่แก้ไขล่าสุด',
    'EVA_NUMBER_OF_GRADES': 'จำนวนที่กรอกเกรด',
    'EVA_QUANTITY': 'จำนวน',
    'EVA_DETAIL': 'รายละเอียด',
    'EVA_CANCEL_EXTEND_DATE':'ยกเลิกขยายวันส่งเกรด',
    'EVA_EXTEND_DATE':'ขยายวันส่งเกรด',
    'EVA_ASSIGN_APPROVE': 'แต่งตั้งผู้กรอกเกรดแทน',
    'EVA_RETURN_PERMISSION_TO_SUBJECT_OWNER': 'คืนสิทธิ์ให้ผู้สอนหลัก',
    'EVA_CHECKING_STATUS': 'สถานะการตรวจสอบ',
    'EVA_SELECT_ITEMS': 'เลือกรายการ',
    'EVA_ENTER_GRADE': 'กรอก-ส่งเกรด',
    'EVA_LIST_OF_STUDENTS_REGISTERING_LATE': 'มีรายการนิสิตลงทะเบียนล่าช้า',
    'EVA_EDIT_GRADE': 'แก้ไขเกรด',
    'EVA_DOC': 'เอกสาร',
    'EVA_ALL_STUDENT': 'นิสิตทั้งหมด',
    'EVA_LIST': 'รายการ',
    'EVA_UPLOAD_GRADE': 'อัปโหลดเกรด',
    'EVA_PULL_GRADE': 'ดึงเกรด',
    'EVA_GRADE': 'เกรด',
    'EVA_LIST_OF_STUDENTS': 'รายชื่อนิสิต',
    'EVA_AVERAGE_SCORE_LEVEL': 'ระดับคะแนนเฉลี่ย',
    'EVA_LIST_OF_STUDENT_W': 'รายชื่อนิสิตถอนติด W',
    'EVA_AMOUNT_OF_PEOPLE': 'จํานวน (คน)',
    'EVA_ALL_SUBJECTS': 'รายวิชาทั้งหมด',
    'EVA_NO': 'ลำดับ',
    'EVA_MAJOR_CODE':'รหัสสาขา',
    'EVA_ENROLLMENT_TYPE': 'ประเภทการลงทะเบียน',
    'EVA_CRITERION': 'เกณฑ์',
    'EVA_NEXT': 'ถัดไป',
    'EVA_SAVE_DRAFT': 'บันทึกร่าง',
    'EVA_NEW_GRADE': 'เกรดใหม่',
    'EVA_CURRENT_GRADE': 'เกรดปัจจุบัน',
    'EVA_FOR_EXAMPLE_A_F': 'เช่น A-F',
    'EVA_CAL_GRADE_A_TO_F': 'คิดจากนิสิตที่ได้เกรด A-F เท่านั้น',
    'EVA_EDIT_GRADE_I_N': 'แก้เกรด I/N',
    'EVA_EDIT_GRADE_TO_GRADE': 'แก้เกรดเป็นเกรด',
    'EVA_IF_NOT_EDIT_I_N_WITHIN_DATE': 'ถ้าไม่มีการแก้ไขเกรด I/N ภายในวันที่',
    'EVA_SYSTEM_AUTO_F': 'ระบบจะปรับเกรดเป็น F โดยอัตโนมัติ',
    'EVA_DOC_NO': 'เลขที่เอกสาร',
    'EVA_KU5_DOC': 'เอกสาร KU5',
    'EVA_KU7_DOC': 'เอกสาร KU7',
    'EVA_GRADE_SUBMISSION_ROUND':'รอบส่งเกรด',
    'EVA_OPEN_PDF': 'เปิดดูแบบ PDF',
    'EVA_HISTORYAPPROVE': 'ประวัติการตรวจสอบ',
    'EVA_GRADE_ANNOUNCEMENT_DATE': 'วันที่ประกาศเกรด',
    'EVA_REASON_LATE_GRADE': 'เหตุผลส่งเกรดล่าช้า',
    'EVA_GRADE_SUBMIT_DATE':'วันที่ส่งเกรด',
    'EVA_STUDENT_SCORE_REPORT': 'ใบรายงานคะแนนของนิสิต',
    'EVA_STUDENT_SCORE_EDIT_REPORT': 'ใบแก้ไขคะแนนของนิสิต',
    'EVA_NORMAL_ROUND': 'ส่งเกรดรอบปกติ',
    'EVA_DELAY_ROUND': 'ส่งเกรดรอบล่าช้า',
    'EVA_EXTEND_ROUND': 'ขยายเวลา',
    'EVA_DELAY_ATTACHMENT': 'เอกสารแนบล่าช้า',
    'EVA_ADDITIONAL_GRADE': 'ส่งเกรดเพิ่มเติม',
    'EVA_CANCEL_APPROVAL': 'ยกเลิกเสนออนุมัติ',
    'EVA_GRADE_SUBMISSION': 'การส่งเกรด',
    'EVA_STAGE_APPROVAL': 'อนุมัติขั้นที่',
    'EVA_TOPIC_SCORE': 'หัวข้อคะแนนเก็บ',
    'EVA_TOPIC_SCORE_HISTORY': 'ประวัติหัวข้อคะแนน',
    'EVA_TOPIC_NAME': 'ชื่อหัวข้อ',
    'EVA_MAX_SCORE': 'คะแนนเต็ม',
    'EVA_PERCENT_WEIGHTED_SCORE': 'ถ่วงน้ำหนัก',
    'EVA_STD_VIEW_SCORE':'นิสิตเห็นคะแนน',
    'EVA_STD_VIEW_STATIC':'นิสิตเห็นสถิติ',
    'EVA_SCORING_STATUS': 'สถานะกรอกคะแนน',
    'EVA_CAL_GRADE': 'คำนวณเกรด',
    'EVA_SCORING': 'กรอกคะแนน',
    'EVA_ADD_TOPIC': 'เพิ่มหัวข้อคะแนนเก็บ',
    'EVA_THIS_SECTION_CANNOT_SET_THE_TOPIC_AND_GRADE': 'หมู่เรียนนี้จะไม่สามารถกำหนดหัวข้อคะแนนและตัดเกรดเองได้',
    'EVA_POINTS': 'คะแนน',
    'EVA_OPERATED_BY_THE_COORDINATOR': 'เนื่องจากมีการจัดกลุ่มสำหรับตัดเกรดรวมหมู่ ต้องดำเนินการโดยผู้ประสานงานเท่านั้น',
    'EVA_SCORE_NOT_OVER': 'เนื่องจากวิชานี้มีการจัดเก็บรวมหมู่คะแนนควรไม่เกิน',
    'EVA_UPLOAD_SCORE': 'อัปโหลดคะแนน',
    'EVA_UPLOAD_PER_COLUMN': 'อัปโหลดคะแนนรายหัวข้อ',
    'EVA_WEIGHTED_SCORE': 'คะแนนถ่วงน้ำหนัก',
    'EVA_SHOW_COLUMN': 'แสดงคอลัมน์',
    'EVA_SHOW_REQUESTS': 'แสดงเฉพาะที่มีคำร้องขอสอบชดเชย/สอบถามเพิ่มเติม',
    'EVA_UPLOAD_ALL_SCORE': 'สำรองข้อมูลคะแนน',
    'EVA_SAVE_SCORE': 'บันทึกคะแนน',
    'EVA_NORMAL_ROUNDING': 'ปัดเศษปกติ (มากกว่าเท่ากับ 5 ปัดขึ้น)',
    'EVA_ROUND_UP': 'ปัดเศษขึ้น (ถ้ามีเศษปัดขึ้นหมด)',
    'EVA_ROUND_DOWN': 'ปัดเศษลง (ตัดเศษออก)',
    'EVA_SAVE_GRADE': 'บันทึกเกรด',
    'EVA_COMPARE_GRAPH': 'กราฟเปรียบเทียบคะแนนแบบอิงเกณฑ์/อิงกลุ่ม',
    'EVA_W': 'ถอนติด W',
    'EVA_COUNT_ALL_STUDENT': 'จำนวนนิสิตทั้งหมด',
    'EVA_CLOSE':'ปิด',
    'EVA_IN_USE': 'ใช้งานอยู่',
    'EVA_DELETE': 'ลบ',
    'EVA_DRAFT': 'แบบร่าง',
    'EVA_NAME_DRAFT': 'ชื่อแบบร่าง',
    'EVA_CONFIRM_DRAFT': 'ยืนยันการบันทึกแบบร่าง',
    'EVA_DELETE_VERSION': 'ลบเวอร์ชั่นสำเร็จ',
    'EVA_SAVE_DRAFT_SUCCESS': 'บันทึกร่างสำเร็จ',
    'EVA_DRAFT_DATA_HAS_BEEN_SAVED': 'บันทึกร่างข้อมูลเรียบร้อยแล้ว',
    'EVA_SELECT_GRADING_FROM': 'เลือกตัดเกรดจาก',
    'EVA_GRADING_CRITERIA': 'ตัดเกรดแบบอิงเกณฑ์',
    'EVA_GRADING_GROUP': 'ตัดเกรดแบบอิงกลุ่ม',
    'EVA_DRAFT_CONFIRM_VERSION': 'แบบร่างที่ยืนยันนำไปใช้งาน',
    'EVA_DEFAULT': 'ค่าเริ่มต้น',
    'EVA_NUMBER_GREATER_THAN': 'จำนวนต้องมากกว่า',
    'EVA_SET_CRITERIA': 'กำหนดเกณฑ์',
    'EVA_SET_GROUP_SD': 'กำหนดตัวคูณ S.D. แบบอิงกลุ่ม',
    'EVA_CRITERIA_GRAPH': 'กราฟอิงเกณฑ์',
    'EVA_GROUP_GRAPH': 'กราฟอิงกลุ่ม',
    'EVA_HIDE_COLOR': 'ซ่อนสี',
    'EVA_CANCEL_HIDE_COLOR': 'ยกเลิกซ่อนสี',
    'EVA_EVA_WEIGHTED_SCORE_LEC' : 'คะแนนถ่วงน้ำหนัก(บรรยาย)',
    'EVA_EVA_WEIGHTED_SCORE_LAB' : 'คะแนนถ่วงน้ำหนัก(ปฏิบัติ)',
    'EVA_NUMBER_OF_GROUP': 'จำนวนหมู่',
    'EVA_ADD_GRADING_GROUP': 'เพิ่มกลุ่มตัดเกรด',
    'EVA_DELETE_GROUP_GRADING': 'ลบกลุ่มตัดเกรด ?',
    'EVA_DO_YOU_WANT_DELETE_GROUP_GRADING': 'คุณต้องการลบข้อมูลกลุ่มตัดเกรดหรือไม่',
    'EVA_DELETE_GROUP_GRADING_SUCCESS': 'ลบกลุ่มตัดเกรดสำเร็จ',
    'EVA_SET_NAME_GROUP_GRADING': 'กำหนดชื่อการตัดเกรดรวมหมู่',
    'EVA_SET_SECTION': 'กำหนดหมู่เรียน',
    'EVA_PLEASE_ENTER_NAME_GROUP_GRADING': 'กรุณากรอกชื่อการตัดเกรดรวมหมู่',
    'EVA_SCORE_ENTERED': 'กรอกคะแนนแล้ว',
    'EVA_SCORE_NOT_ENTERED': 'ยังไม่กรอกคะแนน',
    'EVA_SELECTED_SECTION': 'หมู่เรียนที่เลือก',
    'EVA_DELETE_ALL_SELECTED_SECTION': 'ลบหมู่ที่เลือกทั้งหมด',
    'EVA_TOTAL_WEIGHTED_NOT_OVER': 'โดยคะแนนถ่วงน้ำหนักทั้งหมด ห้ามเกิน',
    'EVA_SET_TOPIC_SCORE': 'กำหนดหัวข้อคะแนนเก็บ',
    'EVA_SET_TOPIC_BY_COORDINATOR': 'กำหนดหัวข้อคะแนนโดยผู้ประสานงาน',
    'EVA_SET_TOPIC_BY_GROUP_TEACHER': 'กำหนดหัวข้อคะแนนโดยอาจารย์ประจำหมู่',
    'EVA_CAL_GRADE_BY_COORDINATOR': 'คำนวณเกรดโดยผู้ประสานงาน',
    'EVA_CAL_GRADE_BY_GROUP_TEACHER': 'คำนวณเกรดโดยอาจารย์ประจำหมู่',
    'EVA_TOTAL_WEIGHTED_NOT_OVER_100_PERCENT': 'คะแนนถ่วงน้ำหนักรวมสูงสุดไม่ควรเกิน 100%',
    'EVA_SET_COURSE': 'กำหนดรายวิชา',
    'EVA_SUBJECT': 'วิชา',
    'EVA_COMPARE_GROUP_GRAPH': 'กราฟเปรียบเทียบคะแนนแบบรวมหมู่',
    'EVA_DRAFT_NO': 'แบบร่างที่',
    'EVA_ALL_SECTION': 'หมู่เรียนทั้งหมด',
    'EVA_TEACHER': 'อาจารย์',
    'EVA_SUBMIT_STATUS': 'สถานะส่งเกรด',
    'EVA_ENTER_SUBJECT_CODE_NAME': 'ระบุรหัสวิชา, ชื่อวิชา',
    'EVA_SUBJECT_CODE': 'รหัสวิชา',
    'EVA_MAIN_TEACHER': 'อ.ผู้สอนหลัก',
    'EVA_CREATE_DOC_DATE': 'วันที่สร้างเอกสาร',
    'EVA_ALL_DOC': 'เอกสารทั้งหมด',
    'EVA_DOC_STATUS_KU5_7': 'สถานะเอกสาร KU5/KU7',
    'EVA_DOC_WAIT_APPROVE': 'เอกสารที่รออนุมัติ',
    'EVA_DOC_APPROVE': 'เอกสารที่อนุมัติแล้ว',
    'EVA_CANCEL_DOC': 'เอกสารที่ยกเลิก',
    'EVA_RETURN_DOC': 'เอกสารส่งคืนเพื่อแก้ไข',
    'EVA_DOC_NOT_APPROVE': 'เอกสารที่ไม่อนุมัติ',
    'EVA_IN_TO_FU_DOC': 'เอกสารเปลี่ยน I,N เป็น F,U อัตโนมัติ',
    'EVA_ACADEMIC_SEMESTER': 'ปี/ภาคการศึกษา',
    'EVA_CHECKING': 'การตรวจสอบ',
    'EVA_STEP': 'ขั้นตอน',
    'EVA_CONFIRM_CANCEL_DOC': 'ยืนยันยกเลิกเอกสาร',
    'EVA_STD_CODE_NAME': 'รหัส/ชื่อนิสิต',
    'EVA_AUTHORIZE_GRADER': 'แต่งตั้งผู้กรอกเกรด',
    'EVA_EDIT': 'แก้ไข',
    'EVA_ALL_LIST': 'รายการทั้งหมด',
    'EVA_HISTORY_EDIT': 'ประวัติการแก้ไข',
    'EVA_OLD_GRADER': 'ผู้กรอกเกรด (เดิม)',
    'EVA_NEW_GRADER': 'ผู้กรอกเกรด (ใหม่)',
    'EVA_SEND_GRADE_I_N': 'ส่งเกรด I และ N',
    'EVA_SEND_GRADE_I': 'ส่งเกรด I',
    'EVA_SEND_GRADE_N': 'ส่งเกรด N',
    'EVA_NOT_SEND_GRADE_I_N': 'ไม่ส่งเกรด I และ N',
    'EVA_SEND_APPROVE': 'ส่งอนุมัติ',
    'EVA_GET': 'ได้รับ',
    'EVA_FILE_LATE_GRADE': 'เอกสารแนบส่งเกรดล่าช้า',
    'EVA_REASON': 'เหตุผล',
    'EVA_ATTACH_FILE': 'แนบไฟล์',
    'EVA_COMFIRM_DISAPPROVE_DOC': 'ยืนยันไม่อนุมัติรายการ',
    'EVA_COMFIRM_CANCEL_DOC': 'ยืนยันยกเลิกรายการ',
    'EVA_TEACHER_CODE_NAME': 'รหัสอาจารย์, ชื่อ-สกุล',
    'EVA_ENTER_TEACHER_CODE_NAME': 'ระบุรหัสอาจารย์, ชื่อ-สกุล',
    'EVA_LAST_DAY_SUBMIT_GRADE': 'วันสุดท้ายในการส่งเกรดรอบปกติ',
    'EVA_EXTEND_DATE_GRADE': 'วันส่งเกรดที่ขอขยาย',
    'EVA_DATE_RECIEVE': 'วันที่ได้รับจริง',
    'EVA_ATTACHMENTS': 'ไฟล์แนบ',
    'EVA_SET_DATE_BY_ADMIN': 'กำหนดวันโดยเจ้าหน้าที่',
    'EVA_DATE_EXTEND': 'วันที่ขอขยาย',
    'EVA_STATUS_APPROVE': 'สถานะอนุมัติ',
    'EVA_WAIT_APPROVE': 'รออนุมัติ',
    'EVA_APPROVE': 'อนุมัติ',
    'EVA_NOT_APPROVE': 'ไม่อนุมัติ',
    'EVA_CONFIRM_REQUEST_DATE': 'ยืนยันตามวันที่ขอ',
    'EVA_CREATE_NEW_REQUEST': 'สร้างคำร้องใหม่',
    'EVA_WAIT_ADMIN_APPROVE': 'รอเจ้าหน้าที่อนุมัติ',
    'EVA_LAST_DATE_OLD_GRADING': 'วันสุดท้ายในการกรอกเกรด (เดิม)',
    'EVA_LAST_DATE_NEW_GRADING': 'วันสุดท้ายในการกรอกเกรด (ใหม่)',
    'EVA_CREATE_DATE': 'วันที่สร้าง',
    'EVA_CREATER': 'ผู้สร้าง',
    'EVA_APPROVER': 'ผู้อนุมัติ',
    'EVA_REQUEST_SPECIAL_CASE': 'คำร้องกำหนดเวลากรณีพิเศษ',
    'EVA_DATE': 'วันที่',
    'EVA_SEMESTER': 'ภาค',
    'EVA_OLD_GRADE': 'เกรดเดิม',
    'EVA_IS_MARK': 'การติด *',
    'EVA_RESTORE': 'คืนสภาพ',
    'EVA_SEARCH_REPORT': 'ค้นหารายงาน',
    'EVA_COURSE_CALENDAR': 'ปฏิทินหลักสูตร',
    'EVA_NORMAL_COURSE_CALENDAR': 'ปฏิทินหลักสูตรปกติ',
    'EVA_INTER_COURSE_CALENDAR': 'ปฏิทินหลักสูตรนานาชาติ',
    'EVA_MEDICAL_COURSE_CALENDAR': 'ปฏิทินหลักสูตรแพทยศาสตร์',
    'EVA_STD_RECIEVE_I': 'นิสิตที่ได้เกรด I',
    'EVA_ALL_SUBJECTS_GRAPH': 'วิชาทั้งหมด',
    'EVA_ENTIRE_SECTION_SEND_I_N': 'หมู่เรียนที่ส่งเกรด I, N ทั้งหมู่',
    'EVA_SECTION_HAVE_BEEN_SUBMITTED_GRADE': 'หมู่เรียนที่ส่งเกรดแล้ว',
    'EVA_SECTION_NOT_SUBMIT_GRADE': 'หมู่เรียนที่ยังไม่ส่งเกรด',
    'EVA_SECTION_NO_REGISTERED_USER': 'หมู่เรียนที่ไม่มีผู้ลงทะเบียน',
    'EVA_SECTION_CLOSED': 'หมู่เรียนที่ปิดสอน',
    'EVA_SEND_NORMAL_GRADE': 'ส่งเกรดปกติ',
    'EVA_SEND_LATE_GRADE': 'ส่งเกรดล่าช้า',
    'EVA_SECTION_SEND_I': 'หมู่เรียนที่ส่งเกรด I',
    'EVA_SECTION_SEND_I_N': 'หมู่เรียนที่แก้ I, N',
    'EVA_SECTION_NOT_SOLVING_I_N': 'หมู่เรียนที่ยังไม่แก้ I, N',
    'EVA_ACADEMIC_SEMESTER_ATTENDED_DATE': 'ปี/ภาคการศึกษาที่เข้าศึกษา',
    'EVA_ACADEMIC_SEMESTER_ELIMINATE': 'ปี/ภาคการศึกษาที่คัดชื่อออก',
    'EVA_EXPORT_REPORT': 'นำออกรายงาน',
    'EVA_OTHER': 'อื่นๆ',
    'EVA_ELIMINATE_REASON': 'เหตุผลที่คัดชื่อออก',
    'EVA_NORMAL_GRADE': 'เกรดปกติ',
    'EVA_GRADE_I': 'เกรด I',
    'EVA_GRADE_N': 'เกรด N',
    'EVA_GRADE_I_N': 'เกรด I และ N',
    'EVA_GRADE_RECIEVE': 'เกรดที่ได้รับ',
    'EVA_TICE_ACADEMIC_SPECIFIED_IN_CURRICULUM': 'ดำรงสถานภาพนิสิตครบกำหนดสองเท่าของจำนวนปีการศึกษาทั้งหมดที่กำหนดไว้ในหลักสูตร หรือสองเท่าของจำนวนภาคการศึกษาปกติที่จำเป็นต้องศึกษา',
    'EVA_GRADE_LESS_ONE_POINT_FIVE': 'มีแต้มคะแนนเฉลี่ยสะสมต่ำกว่า 1.50 ยกเว้นภาคการศึกษาแรกของนิสิตใหม่',
    'EVA_BELOW_ONE_POINT_SEVEN_FIVE_IN_TWO_SEMESTER': 'มีแต้มคะแนนเฉลี่ยสะสมต่ำกว่า 1.75 เป็นเวลาสองภาคการศึกษาปกติติดต่อกัน ทั้งนี้ ไม่นับภาคการศึกษาแรกของนิสิตใหม่',
    'EVA_NO_REGIS_SINCE_FIRST_SEMESTER': 'ไม่ลงทะเบียนเรียนหรือไม่ลงทะเบียนรักษาสถานภาพให้เสร็จสิ้นภายในสองสัปดาห์แรก นับแต่วันเปิดภาคเรียน',
    'EVA_RESULT': 'ผลการค้นหา',
    'EVA_GRADE_EDITING_TYPE': 'ประเภทการแก้ไขเกรด',
    'EVA_CURRICULUM': 'หลักสูตร(หลักสูตรปกติ/หลักสุตรนานาชาติ)',
    'EVA_STD_REGIS_LATE': 'นิสิตลงทะเบียนล่าช้า',
    'EVA_RESTORE_UPLOAD': 'นำเข้าไฟล์สำรองข้อมูล',
    'EVA_CHECK_REPORT': 'ตรวจสอบใบรายงาน/แก้ไขคะแนน',
    'EVA_EXTEND_DATE_EDIT_GRADE':'ขยายวันแก้ไขเกรด',
}
